import React, { PureComponent } from 'react'

import { apiImageUrl } from 'lib/utils'
import './style.scss'

class GalleryItem extends PureComponent {
  onClick = () => {
    if(this.props.onClick)
      this.props.onClick(this.props.itemId)
  }

  render() {
    const {
      itemId
    } = this.props

    const imageUrl = apiImageUrl('WebImageThumbnail', itemId)

    return (
      <div className="galleryItem" onClick={this.onClick}>
        <img src={imageUrl} alt="gallery" />
      </div>
    )
  }
}

export default GalleryItem